import { Directive } from "@angular/core";

@Directive({
    selector: '[t4CustomContent]',
    standalone: false
})
  export class CustomContentDirective {}
